/**
 * @generated SignedSource<<08daafcf3164e8245b2eee267b791727>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BottomBar_viewer$data = {
  readonly footerSupportLinks: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNav_viewer">;
  readonly " $fragmentType": "BottomBar_viewer";
};
export type BottomBar_viewer$key = {
  readonly " $data"?: BottomBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BottomBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_viewer",
  "selections": [
    {
      "alias": "footerSupportLinks",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "footerSupportLinks"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"footerSupportLinks\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e87ce02171b5ced372f52d48513d5500";

export default node;
